import * as React from "react";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import Grid from "@mui/material/Grid";
import { styled } from "@mui/material/styles";
import Paper from "@mui/material/Paper";
import DoDisturbIcon from "@mui/icons-material/DoDisturb";
import TextCard from "../cards/TextCard";
import { useHistory } from "react-router-dom";

const style = {
  position: "absolute" as "absolute",
  top: "40%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 4,
};

export default function ModalBluCmp({ openModel, inputLoanRequestId }: any) {
  const [open, setOpen] = React.useState(openModel);
  const [loanRequestId, setLoanRequestId] = React.useState(inputLoanRequestId);
  const handleClose = () => setOpen(false);
  const history = useHistory();
  React.useEffect(() => {
    setOpen(openModel);
  }, [openModel]);
  React.useEffect(() => {
    setLoanRequestId(inputLoanRequestId);
  }, [inputLoanRequestId]);

  const goToDetail = () => {
    history.push(`/loan/loan-detail/${loanRequestId}`);
  };

  return (
    <div>
      <Modal
        keepMounted
        open={open}
        onClose={handleClose}
        aria-labelledby="keep-mounted-modal-title"
        aria-describedby="keep-mounted-modal-description"
      >
        <Box
          sx={style}
          style={{ borderRadius: "6px" }}
          className="ModalCmp textCenter"
        >
          <Typography className="textCenter mTop30 mbottom20">
            تسهیلات پس از امضای مشتری به مشتری اعطا خواهد شد
          </Typography>
          <Grid>
            <img src="images/approve.png" />
          </Grid>
          <Grid container spacing={2} columns={16} className="mTop20">
            <Button
              fullWidth
              className="btnForm SuccessDefault  mTop40"
              onClick={goToDetail}
            >
              ادامه
            </Button>
          </Grid>
        </Box>
      </Modal>
    </div>
  );
}
